import React from "react";
import PropTypes from "prop-types";

import AbstractDropdown from "components/library/AbstractDropdown";

export default function AsyncDropdown(props) {
  return <AbstractDropdown isAsync={true} {...props} />;
}

// This component can take all the same props as react-select but these are required for render.
AsyncDropdown.propTypes = {
  loadOptions: PropTypes.func.isRequired,
};
